import React, { useState } from 'react'
// Material UI Theme
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { makeStyles, Card, CardContent, Typography, Button } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
// Functions
import fileDownload from '../../func/fileDownload'

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginBottom: '2rem',
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
  },
  content: {
    position: 'relative',
  },
  dlArea: {
    "@media (min-width: 768px)": {
      display: 'flex',
      alignItems: 'center',
    }
  },
  ul: {
    listStyle: 'none',
    marginBottom: 0,
  },
  listItem: {
    marginTop: 12,
    'first-child': {
      marginTop: 0,
    },
  },
  btns: {
    marginLeft: '2rem',
  },
  dlBtn: {
    fontSize: 11,
    display: 'block',
    marginTop: 12,
    'first-child': {
      marginTop: 0,
    },
    "@media (max-width: 767px)": {
      display: 'none',
    },
  },
  dlSpBtn: {
    "@media (max-width: 767px)": {
      display: 'block',
    },
    "@media (min-width: 768px)": {
      display: 'none',
    }
  },
  pos: {
    margin: '0 0 .5rem',
    wordBreak: 'break-all',
  },
})

// Material UI Theme
const theme = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        fontSize: 11,
        padding: '5px 10px',
      },
      label: {
        display: 'inline',
      },
      iconSizeMedium: {
        '& > *:first-child': {
          fontSize: 16,
        }
      }
    },
  }
})

export default function Note({ mainText, textList }) {
  const classes = useStyles()

  return (
    <ThemeProvider theme={theme}>
      <Card className={classes.root}>
        <CardContent className={classes.content}>
          <Typography
            className={classes.pos}
            component="p"
            dangerouslySetInnerHTML={{
              __html: mainText
            }}
          />
          <div className={classes.dlArea}>
            <ul className={classes.ul}>
              {textList.map((list, index) => (
                <li key={index} className={classes.listItem}>
                  {list.text}
                  <Button
                    variant="contained"
                    startIcon={<GetAppIcon />}
                    className={classes.dlSpBtn}
                    onClick={() => fileDownload(list.fileName)}
                  >
                    ダウンロード
                  </Button>
                </li>
              ))}
            </ul>
            <div className={classes.btns}>
              {textList.map((list, index) => (
                <Button
                  variant="contained"
                  startIcon={<GetAppIcon />}
                  className={classes.dlBtn}
                  onClick={() => fileDownload(list.fileName)}
                  key={index}
                >
                  ダウンロード
                </Button>
              ))}
            </div>
          </div>
        </CardContent>
      </Card >
    </ThemeProvider>
  )
}